import React from 'react';
import { connect } from 'react-redux';
import InternalContainer from '../../layout/containers/Internal';
import MtaList from '../components/MtaList/MtaList';
import { getCurrentBroker } from '../../auth/redux/authActions';

const MtaListContainer = () => {
  const currentBroker = getCurrentBroker();
  return (
    <InternalContainer title="Mid Term Adjustments">
      <MtaList currentBroker={currentBroker?.data?.id} />
    </InternalContainer>
  );
};

export default connect((state) => {
  return {
    auth: state.auth,
  };
})(MtaListContainer);
